import { render, staticRenderFns } from "./HeadlineTitle.vue?vue&type=template&id=b568d572"
import script from "./HeadlineTitle.vue?vue&type=script&lang=ts"
export * from "./HeadlineTitle.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineTitle.vue?vue&type=style&index=0&id=b568d572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports